module.exports = __webpack_public_path__ + "media/images/loghi/lba_white-bea75dc197240792e85f9a090546bafd.png";